<template>
	<v-dialog
		v-model="show"
		scrollable
		max-width="100%"
		@input="close()"
		transition="dialog-transition">
		<v-card class="background">
			<v-card-title
				class="py-1 px-3 primary color--text subheading word-break-all">
				<v-btn flat icon color="color" class="my-0" @click="openFile()">
					<v-icon>folder</v-icon>
				</v-btn>
				{{ file_path }}
				<v-spacer></v-spacer>
				<v-btn flat icon color="color" class="my-0" @click="close()">
					<v-icon>close</v-icon>
				</v-btn>
			</v-card-title>
			<v-card-text class="pa-0" v-if="show" style="height: 80vh">
				<v-container grid-list-xs v-if="loading || error">
					<v-progress-linear
						v-if="loading"
						color="primary"
						indeterminate>
					</v-progress-linear>
					<v-alert type="error" class="pa-2 ma-0" :value="error !== null">
						{{ error }}
					</v-alert>
				</v-container>
				<AceEditor
					v-if="!loading && file_content"
					:code="file_content"
					theme="monokai"
					height="100%"
					width="100%"
					:language="language"
					:readonly="true">
				</AceEditor>
			</v-card-text>
		</v-card>
	</v-dialog>
</template>

<script>
import AceEditor from '@/components/ace_editor.vue'
const Path = require('path')
export default {
	components: { AceEditor },
	props: {
		file_path: {
			type: String,
			required: false,
			default: ''
		}
	},
	data () {
		return {
			show: false,
			loading: false,
			file_content: null,
			language: null,
			error: null
		}
	},
	watch: {
		file_path (value) {
			this.file_content = null
			this.error = null
			this.language = null
			if (!value) {
				this.show = false
				return
			}
			this.loading = true
			this.show = true
			this.$ApiNexus.cat(value)
				.then(result => {
					this.language = this.guessLanguage(value)
					this.file_content = result.data
				})
				.catch(error => {
					console.error('readFile error', error.response)
					this.error = error.response.data.error
				})
				.finally(() => {
					this.loading = false
				})
		}
	},
	methods: {
		openFile () {
			this.$FileOpener.fileOpener('show', this.file_path)
				.catch(error => {
					console.error('openWorkingDir error', error)
				})
		},
		guessLanguage (file_path) {
			let ext = Path.extname(file_path).toUpperCase()
			if (['.XML', '.EZTXML', '.ITT', '.TTML', '.DFXP', '.CML'].indexOf(ext) > -1) {
				return 'xml'
			}
			if (ext === '.JSON') {
				return 'json'
			}
			return 'text'
		},
		close () {
			this.show = false
			this.file_content = null
			this.error = null
			this.$emit('close')
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/file_reader_modal.vue